var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundWaitingRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1366,
    height: 654,
    viewBox: "0 0 1366 654",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2414_8279)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 654,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1383 558H-1V1056H1383V558Z",
    fill: "#D3D7D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767 558L945 857",
    stroke: "#DEE1E2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645 558L722 866",
    stroke: "#DEE1E2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 558L519 876",
    stroke: "#DEE1E2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380 558L284 876",
    stroke: "#DEE1E2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239 559L63 855",
    stroke: "#DEE1E2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 559L-129 855",
    stroke: "#DEE1E2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920 558L1136 835",
    stroke: "#DEE1E2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1082 558L1320 832",
    stroke: "#DEE1E2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-42 634H1432",
    stroke: "#DEE1E2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275 558L1513 832",
    stroke: "#DEE1E2",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1319 525V417.267C1319 403.316 1329.22 392 1341.82 392H1412.18C1424.78 392 1435 403.316 1435 417.267V525H1319Z",
    fill: "#B5241F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435 417.556V422C1435 407.895 1424.78 396.444 1412.18 396.444H1341.82C1329.22 396.444 1319 407.895 1319 422V417.556C1319 403.451 1329.22 392 1341.82 392H1412.18C1424.78 391.987 1435 403.438 1435 417.556Z",
    fill: "#DF2C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435 531H1319V535H1435V531Z",
    fill: "#921D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435 526.269V531.731C1435 536.845 1430.85 541 1425.74 541H1328.26C1323.14 541 1319 536.845 1319 531.731V526.269C1319 521.155 1323.14 517 1328.26 517H1425.74C1430.85 517 1435 521.155 1435 526.269Z",
    fill: "#921D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1434 602L1431 597.893V564L1436 567.524L1434 602Z",
    fill: "#DF2C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1426 570H1444V507H1426V570Z",
    fill: "#6B1714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1434 602H1439V570H1434V602Z",
    fill: "#6B1714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1444 480V509.92C1444 514.94 1439.98 519 1435 519C1432.53 519 1430.27 517.988 1428.64 516.346C1427 514.69 1426 512.43 1426 509.92V480H1444Z",
    fill: "#921D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1444 480V486.907C1443.67 486.96 1443.35 487 1443.02 487H1426.98C1426.65 487 1426.31 486.96 1426 486.907V480H1444Z",
    fill: "#6B1714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1440.6 484H1428.4C1424.31 484 1421 480.611 1421 476.427V473.573C1421 469.389 1424.31 466 1428.4 466H1440.6C1444.69 466 1448 469.389 1448 473.573V476.427C1448 480.611 1444.69 484 1440.6 484Z",
    fill: "#921D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1448 471.953V474C1448 470.709 1445.47 468.047 1442.33 468.047H1426.67C1423.54 468.047 1421 470.709 1421 474V471.953C1421 468.662 1423.54 466 1426.67 466H1442.33C1445.47 466 1448 468.662 1448 471.953Z",
    fill: "#DF2C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190 525V417.267C1190 403.316 1200.22 392 1212.82 392H1283.18C1295.78 392 1306 403.316 1306 417.267V525H1190Z",
    fill: "#B5241F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306 417.556V422C1306 407.895 1295.78 396.444 1283.18 396.444H1212.82C1200.22 396.444 1190 407.895 1190 422V417.556C1190 403.451 1200.22 392 1212.82 392H1283.18C1295.78 391.987 1306 403.438 1306 417.556Z",
    fill: "#DF2C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306 531H1190V535H1306V531Z",
    fill: "#921D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306 526.269V531.731C1306 536.845 1301.85 541 1296.74 541H1199.26C1194.14 541 1190 536.845 1190 531.731V526.269C1190 521.155 1194.14 517 1199.26 517H1296.74C1301.85 517 1306 521.155 1306 526.269Z",
    fill: "#921D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059 525V417.267C1059 403.316 1069.22 392 1081.82 392H1152.18C1164.78 392 1175 403.316 1175 417.267V525H1059Z",
    fill: "#B5241F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175 417.556V422C1175 407.895 1164.78 396.444 1152.18 396.444H1081.82C1069.22 396.444 1059 407.895 1059 422V417.556C1059 403.451 1069.22 392 1081.82 392H1152.18C1164.78 391.987 1175 403.438 1175 417.556Z",
    fill: "#DF2C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175 531H1059V535H1175V531Z",
    fill: "#921D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175 526.269V531.731C1175 536.845 1170.85 541 1165.74 541H1068.26C1063.14 541 1059 536.845 1059 531.731V526.269C1059 521.155 1063.14 517 1068.26 517H1165.74C1170.85 517 1175 521.155 1175 526.269Z",
    fill: "#921D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181 602L1178 597.893V564L1183 567.524L1181 602Z",
    fill: "#DF2C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173 570H1191V507H1173V570Z",
    fill: "#6B1714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181 602H1186V570H1181V602Z",
    fill: "#6B1714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191 480V509.92C1191 514.94 1186.98 519 1182 519C1179.53 519 1177.27 517.988 1175.64 516.346C1174 514.69 1173 512.43 1173 509.92V480H1191Z",
    fill: "#921D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1191 480V486.907C1190.67 486.96 1190.35 487 1190.02 487H1173.98C1173.65 487 1173.31 486.96 1173 486.907V480H1191Z",
    fill: "#6B1714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.6 484H1175.4C1171.31 484 1168 480.611 1168 476.427V473.573C1168 469.389 1171.31 466 1175.4 466H1187.6C1191.69 466 1195 469.389 1195 473.573V476.427C1195 480.611 1191.69 484 1187.6 484Z",
    fill: "#921D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195 471.953V474C1195 470.709 1192.47 468.047 1189.33 468.047H1173.67C1170.54 468.047 1168 470.709 1168 474V471.953C1168 468.662 1170.54 466 1173.67 466H1189.33C1192.47 466 1195 468.662 1195 471.953Z",
    fill: "#DF2C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1314 602L1311 597.893V564L1316 567.524L1314 602Z",
    fill: "#DF2C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306 570H1324V507H1306V570Z",
    fill: "#6B1714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1314 602H1319V570H1314V602Z",
    fill: "#6B1714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324 480V509.92C1324 514.94 1319.98 519 1315 519C1312.53 519 1310.27 517.988 1308.64 516.346C1307 514.69 1306 512.43 1306 509.92V480H1324Z",
    fill: "#921D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324 480V486.907C1323.67 486.96 1323.35 487 1323.02 487H1306.98C1306.65 487 1306.31 486.96 1306 486.907V480H1324Z",
    fill: "#6B1714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.6 484H1308.4C1304.31 484 1301 480.611 1301 476.427V473.573C1301 469.389 1304.31 466 1308.4 466H1320.6C1324.69 466 1328 469.389 1328 473.573V476.427C1328.01 480.611 1324.69 484 1320.6 484Z",
    fill: "#921D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328 471.953V474C1328 470.709 1325.47 468.047 1322.33 468.047H1306.67C1303.54 468.047 1301 470.709 1301 474V471.953C1301 468.662 1303.54 466 1306.67 466H1322.33C1325.46 466 1328 468.662 1328 471.953Z",
    fill: "#DF2C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053 602L1050 597.893V564L1055 567.524L1053 602Z",
    fill: "#DF2C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045 570H1063V507H1045V570Z",
    fill: "#6B1714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053 602H1058V570H1053V602Z",
    fill: "#6B1714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063 480V509.92C1063 514.94 1058.98 519 1054 519C1051.53 519 1049.27 517.988 1047.64 516.346C1046 514.69 1045 512.43 1045 509.92V480H1063Z",
    fill: "#921D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063 480V486.907C1062.67 486.96 1062.35 487 1062.02 487H1045.98C1045.65 487 1045.31 486.96 1045 486.907V480H1063Z",
    fill: "#6B1714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.6 484H1047.4C1043.31 484 1040 480.611 1040 476.427V473.573C1040 469.389 1043.31 466 1047.4 466H1059.6C1063.69 466 1067 469.389 1067 473.573V476.427C1067 480.611 1063.69 484 1059.6 484Z",
    fill: "#921D19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1067 471.953V474C1067 470.709 1064.47 468.047 1061.33 468.047H1045.67C1042.54 468.047 1040 470.709 1040 474V471.953C1040 468.662 1042.54 466 1045.67 466H1061.33C1064.47 466 1067 468.662 1067 471.953Z",
    fill: "#DF2C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1286 113H1123V348H1286V113Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296 118H1113V125H1296V118Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296 126H1113V133H1296V126Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296 135H1113V142H1296V135Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296 143H1113V150H1296V143Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296 151H1113V158H1296V151Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296 159H1113V166H1296V159Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280 117H1279V233H1280V117Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282 240H1277L1278.25 233H1280.75L1282 240Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285 117H1284V269H1285V117Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1287 274H1282L1283.26 267H1285.75L1287 274Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118 108V353H1292V108H1118ZM1286.83 347.838H1123.18V113.137H1286.83V347.838Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207 115H1202V351H1207V115Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304 107H1105V122H1304V107Z",
    fill: "#DADDDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 175H200V559H135V175Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 172H314V560L135 559V172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 514C180.47 514 179.961 513.757 179.586 513.324C179.211 512.891 179 512.304 179 511.692V501.308C179 500.696 179.211 500.109 179.586 499.676C179.961 499.243 180.47 499 181 499C181.53 499 182.039 499.243 182.414 499.676C182.789 500.109 183 500.696 183 501.308V511.692C183 512.304 182.789 512.891 182.414 513.324C182.039 513.757 181.53 514 181 514Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194 514C193.47 514 192.961 513.757 192.586 513.324C192.211 512.891 192 512.304 192 511.692V501.308C192 500.696 192.211 500.109 192.586 499.676C192.961 499.243 193.47 499 194 499C194.53 499 195.039 499.243 195.414 499.676C195.789 500.109 196 500.696 196 501.308V511.692C196 512.304 195.789 512.891 195.414 513.324C195.039 513.757 194.53 514 194 514Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290 514C289.47 514 288.961 513.757 288.586 513.324C288.211 512.891 288 512.304 288 511.692V501.308C288 500.696 288.211 500.109 288.586 499.676C288.961 499.243 289.47 499 290 499C290.53 499 291.039 499.243 291.414 499.676C291.789 500.109 292 500.696 292 501.308V511.692C292 512.304 291.789 512.891 291.414 513.324C291.039 513.757 290.53 514 290 514Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 514C302.47 514 301.961 513.757 301.586 513.324C301.211 512.891 301 512.304 301 511.692V501.308C301 500.696 301.211 500.109 301.586 499.676C301.961 499.243 302.47 499 303 499C303.53 499 304.039 499.243 304.414 499.676C304.789 500.109 305 500.696 305 501.308V511.692C305 512.304 304.789 512.891 304.414 513.324C304.039 513.757 303.53 514 303 514Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.19 423H133.81C133.33 423 132.87 422.789 132.53 422.414C132.191 422.039 132 421.53 132 421C132 420.47 132.191 419.961 132.53 419.586C132.87 419.211 133.33 419 133.81 419H208.19C208.67 419 209.13 419.211 209.47 419.586C209.809 419.961 210 420.47 210 421C210 421.53 209.809 422.039 209.47 422.414C209.13 422.789 208.67 423 208.19 423Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 415H187V419H190V415Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 415H173V419H176V415Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143 207H141V367H143V207Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 207H248V367H250V207Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.449 217H134.551L132 210H258L255.449 217Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.449 227H134.551L132 220H258L255.449 227Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.449 237H134.551L132 230H258L255.449 237Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.449 247H134.551L132 240H258L255.449 247Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.449 256H134.551L132 249H258L255.449 256Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.449 266H134.551L132 259H258L255.449 266Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.449 276H134.551L132 269H258L255.449 276Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.449 286H134.551L132 279H258L255.449 286Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.449 296H134.551L132 289H258L255.449 296Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.449 306H134.551L132 299H258L255.449 306Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.449 316H134.551L132 309H258L255.449 316Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.449 325H134.551L132 318H258L255.449 325Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.449 335H134.551L132 328H258L255.449 335Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.449 345H134.551L132 338H258L255.449 345Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.449 355H134.551L132 348H258L255.449 355Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.449 365H134.551L132 358H258L255.449 365Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258 365H132V369H258V365Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263 201H128V211H263V201Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.5 297C129.102 297 128.721 296.826 128.439 296.517C128.158 296.208 128 295.789 128 295.352V239.648C128 239.211 128.158 238.792 128.439 238.483C128.721 238.174 129.102 238 129.5 238C129.898 238 130.279 238.174 130.561 238.483C130.842 238.792 131 239.211 131 239.648V295.352C131 295.789 130.842 296.208 130.561 296.517C130.279 296.826 129.898 297 129.5 297Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130 209H129V242H130V209Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.406 373H162.594C160.846 373.003 159.17 373.794 157.934 375.199C156.698 376.604 156.003 378.51 156 380.497V383H159.551V380.486C159.55 380.031 159.627 379.58 159.78 379.159C159.932 378.738 160.156 378.355 160.439 378.033C160.722 377.71 161.058 377.454 161.427 377.28C161.797 377.105 162.194 377.015 162.594 377.015H180.406C181.214 377.018 181.988 377.385 182.558 378.036C183.129 378.686 183.449 379.568 183.449 380.486V382.989H187V380.486C186.997 378.5 186.302 376.596 185.065 375.192C183.829 373.788 182.153 373 180.406 373Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196 388.673V412.327C196 413.832 195.504 415.275 194.622 416.339C193.74 417.402 192.544 418 191.297 418H148.703C147.456 418 146.26 417.402 145.378 416.339C144.496 415.275 144 413.832 144 412.327V388.673C144 387.168 144.496 385.725 145.378 384.662C146.26 383.598 147.456 383 148.703 383H191.259C191.88 382.994 192.496 383.136 193.07 383.419C193.645 383.701 194.168 384.118 194.609 384.646C195.05 385.173 195.4 385.8 195.638 386.491C195.877 387.183 196 387.924 196 388.673Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181 388H159V415H181V388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 400V403H177V400H172Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 400V403H169V400H164Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 395H169V408H172V395Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326 160H123V559H135.355V172.173H313.645V559H326V160Z",
    fill: "#977658"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 596V159L314 171.984V560.041L200 596Z",
    fill: "#C19E7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311 560V171L314 171.34V559.052L311 560Z",
    fill: "#A58262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257 189.294L219 185V336L257 333.224V189.294Z",
    fill: "#A58262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253 188.915L219 185V336L253 333.48V188.915Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.989 419.545C227.989 420.839 227.725 422.104 227.232 423.181C226.738 424.257 226.036 425.096 225.214 425.591C224.393 426.086 223.49 426.216 222.618 425.964C221.746 425.711 220.945 425.088 220.316 424.172C219.688 423.257 219.26 422.091 219.086 420.821C218.913 419.552 219.002 418.236 219.342 417.04C219.682 415.844 220.258 414.822 220.997 414.103C221.737 413.384 222.606 413 223.494 413C224.085 412.998 224.67 413.166 225.216 413.494C225.762 413.822 226.258 414.304 226.676 414.913C227.093 415.521 227.424 416.243 227.65 417.038C227.875 417.833 227.99 418.685 227.989 419.545Z",
    fill: "#AD8E76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.989 426.089C230.471 426.089 232.483 423.159 232.483 419.545C232.483 415.93 230.471 413 227.989 413C225.506 413 223.494 415.93 223.494 419.545C223.494 423.159 225.506 426.089 227.989 426.089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 68.01H377L374.426 62.1557C368.484 48.6689 355.141 39.9648 340.406 39.9648H108.589C95.2454 39.9648 82.9294 47.1114 76.313 58.7095L71 68.01Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.506 -0.0078125H328.897V41.1376H325.506V-0.0078125Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.103 -0.0078125H122.494V41.1376H119.103V-0.0078125Z",
    fill: "#EFEFEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2414_8279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 654,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundWaitingRoom);
export default __webpack_public_path__ + "static/media/backgroundWaitingRoom.2fc232fc88f9aca33d29c69d7f7760d2.svg";
export { ForwardRef as ReactComponent };